export default "__VITE_ASSET__BsIwkowe__"